module.exports = __webpack_public_path__ + "static/media/example-3.41c72c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Churchview/example-3.jpg
// module id = 228
// module chunks = 0